var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Create Membership",
        "header-bg-variant": "success",
        "header-text-variant": "light",
        size: "lg",
        visible: _vm.showModal,
        centered: ""
      },
      on: { hidden: _vm.reset },
      scopedSlots: _vm._u([
        {
          key: "modal-header-close",
          fn: function() {
            return [_c("h4", [_vm._v("X")])]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "b-form",
        [
          _c(
            "b-row",
            [
              _c(
                "h2",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.createUserMembershipPending,
                      expression: "createUserMembershipPending"
                    }
                  ],
                  staticClass: "u-padding-bottom-20"
                },
                [_vm._v("Updating, please wait ...")]
              ),
              _vm._v(" "),
              _c("pulse-loader", {
                attrs: {
                  loading: _vm.createUserMembershipPending,
                  color: "#0F347B",
                  size: "50px"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-select",
            {
              attrs: {
                id: "selectedOrganization",
                size: "lg",
                options: _vm.memberOrganizationOptions(_vm.organizations)
              },
              model: {
                value: _vm.morganization,
                callback: function($$v) {
                  _vm.morganization = $$v
                },
                expression: "morganization"
              }
            },
            [
              _c(
                "option",
                { attrs: { disabled: "" }, domProps: { value: null } },
                [_vm._v("-- Please select an organization --")]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "b-form-checkbox",
            {
              staticClass: "m-3",
              attrs: {
                id: "orgAdmin",
                name: "orgAdmin",
                "unchecked-value": false,
                switch: "",
                inline: ""
              },
              model: {
                value: _vm.isOrgAdmin,
                callback: function($$v) {
                  _vm.isOrgAdmin = $$v
                },
                expression: "isOrgAdmin"
              }
            },
            [
              _vm._v(
                "\n      Organization Admin - Would you like this user to be able to share, unshare and transfer records on behalf of\n      your organization?\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "b-form-checkbox",
            {
              staticClass: "m-3",
              attrs: {
                id: "orgManager",
                name: "orgManager",
                "unchecked-value": false,
                switch: "",
                inline: ""
              },
              model: {
                value: _vm.isManager,
                callback: function($$v) {
                  _vm.isManager = $$v
                },
                expression: "isManager"
              }
            },
            [
              _vm._v(
                "\n      Organization Manager - Would you like this user to be able to view all of the records for your organization?\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "b-form-checkbox",
            {
              staticClass: "m-3",
              attrs: {
                id: "dwUser",
                name: "dwUser",
                "unchecked-value": false,
                switch: "",
                inline: ""
              },
              model: {
                value: _vm.isDWUser,
                callback: function($$v) {
                  _vm.isDWUser = $$v
                },
                expression: "isDWUser"
              }
            },
            [
              _vm._v(
                "\n        Data Warehouse User: Would you like this user to be able to access the Lighthouse Data Warehouse application?\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "b-form-checkbox",
            {
              staticClass: "m-3",
              attrs: {
                id: "careCoordinator",
                name: "careCoordinator",
                "unchecked-value": false,
                switch: "",
                inline: ""
              },
              model: {
                value: _vm.isCareCoordinator,
                callback: function($$v) {
                  _vm.isCareCoordinator = $$v
                },
                expression: "isCareCoordinator"
              }
            },
            [
              _vm._v(
                "\n      Care Coordinator: Would you like this user to access the Victim Identification tab designed for care coordinators?\n    "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          attrs: {
            fade: "",
            show:
              _vm.createUserMembershipFailure ||
              _vm._.isObject(_vm.createUserMembershipSuccess),
            variant: _vm.createUserMembershipFailure ? "danger" : "success"
          }
        },
        [
          _c("span", {
            domProps: { innerHTML: _vm._s(_vm.apiResponseMessage()) }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { slot: "modal-footer" },
          slot: "modal-footer"
        },
        [
          _c(
            "b-button",
            {
              staticClass: "float-right",
              attrs: { type: "button", variant: "primary" },
              on: { click: _vm.userMemberHandler }
            },
            [_c("span", { staticClass: "button-text" }, [_vm._v("Create")])]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02827028", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02827028","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/CreateUserMemberModal.vue
// module id = 1826
// module chunks = 0